module.exports = {
  NODE_ENV: 'production',
  api_url: 'https://api.apps.rog-gaming.net',
  saml_url: 'https://saml.rog-gaming.net/saml/login?idp=https://asusfs.asus.com/adfs/services/trust',
  port: 80
}
